<template>
    <div>
        <div class="modal show d-block composer-modal" tabindex="-1" role="dialog" ref="modal">
            <div class="modal-dialog" role="document">
                <div ref="form" class="modal-content" enctype="multipart/form-data" @submit.prevent="handleSubmit">
                    <div class="modal-header">
                        <h5 class="modal-title" v-text="modalTitle"></h5>
                        <button type="button" class="close" @click.prevent="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <select class="image-picker show-html mb20" ref="selector">
                                    <!--optgroup label="In wrapper"-->
                                    <option v-for="rowType in rowTypes"
                                            :key="rowType.name"
                                            :data-img-label="getTypeTranslation(rowType.name)"
                                            v-text="getTypeTranslation(rowType.name)"
                                            :data-img-src="rowType.icon"
                                            :value="rowType.id"
                                    ></option>
                                    <!--/optgroup-->
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="close">Sluiten</button>
                        <button type="submit" class="btn btn-success" :class="{loading: saving}"
                                @click.prevent="handleSubmit">Toevoegen
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" @click.prevent="close"></div>
    </div>
</template>

<script>
    require('image-picker');

    import Spinner from './Spinner';

    export default {
        components: {
            Spinner
        },
        props: {
            types: {
                required: true,
                type: Array
            }
        },
        data: function () {
            return {
                loadRowTypes: false,
                rowTypes: [],
                selectedType: null,
                saving: false,
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            handleSubmit() {
                this.$emit('selected', this.selectedType);
                this.saving = true;
            },
            getTypeTranslation(key) {
                return this.$store.state.composer.translations.type[key] || key;
            }
        },
        computed: {
            modalTitle() {
                return _.get(this.row, 'type.name', 'Rij toevoegen');
            }
        },
        watch: {},
        mounted() {
            $(this.$refs.selector).imagepicker({
                hide_select: false,
                show_label: true,
                initialized: () => {
                    if (this.types.length > 0) {
                        this.selectedType = `${this.types[0].id}`;
                    }
                },
                selected: (select, option, event) => {
                    this.selectedType = select.value();
                },
            });

        },
        created() {
            this.rowTypes = this.types;
        }

    }
</script>

<style>
    .image_picker_selector .thumbnail {
        min-height: 150px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }
</style>

<style scoped>
    /* fixme: z-index is workaround */
    .composer-modal .modal-dialog {
        z-index: 1050;
    }

    /* fixme: should be fixed in `development` */
    .modal-content {
        max-height: 95vh;
    }

    .modal-body {
        /*max-height: 75vh;*/
        overflow-y: auto;
    }

    /* end of fixme */
</style>
